<button
  [ngClass]="{
    'transparent-bg': removeBackground(),
    'background-red': backgroundType() === 'red',
    noHover: disabledhover(),
  }"
  class="button-icon"
  type="button"
  [style.pointerEvents]="myStyle()"
  [disabled]="disabled()"
>
  <div class="button-icon__image-container">
    <img class="icon" [src]="icon()" [alt]="iconalt()" />
  </div>
</button>
